export default {
    postTitle: {
        prefix: "Featured image for post titled ",
        suffix: ""
    }
}
